/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { authCompleteOnboarding } from '../../axios/authCompleteOnboarding'
import type { AuthCompleteOnboardingError, AuthCompleteOnboardingResponse } from '../../types/AuthCompleteOnboarding'

export const authCompleteOnboardingMutationKey = () => [{ url: '/auth/me/onboarding/complete' }] as const

export type AuthCompleteOnboardingMutationKey = ReturnType<typeof authCompleteOnboardingMutationKey>

/** @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::completeOnboarding */
export function useAuthCompleteOnboarding<TContext = unknown>(
	options?: UseMutationOptions<
		AuthCompleteOnboardingResponse,
		AxiosError<AuthCompleteOnboardingError>,
		void,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: authCompleteOnboardingMutationKey(),
		mutationFn: () => authCompleteOnboarding(config).then(res => res.data),
		...options,
	})
}
